export enum Roles {
    MANAGER = 'manager',
    ADMIN = 'admin',
    TEAMLEAD = 'teamleader',
}

const MANAGEMENT_ROLES: string[] = [Roles.ADMIN, Roles.MANAGER, Roles.TEAMLEAD];

export const hasManagementRole = (role: string | null): boolean => role !== null && MANAGEMENT_ROLES.includes(role);
